import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import CountrySelector from '../../components/CountrySelector/CountrySelector';
import DateService from '../../services/DateService';
import VideoListStore from '../../store/VideoListStore';
import './filters.scss';
import LanguageStore from '../../store/LanguageStore';

const Filters = observer(() => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [showAfterButton, setShowAfterButton] = useState(false);
    const [beforeDayDate, setBeforeDayDate] = useState('');
    const [afterDayDate, setAfterDayDate] = useState('');
    const {countryCode, trackedAt, onlyNew} = VideoListStore;

    useEffect(() => {
        const params = new URLSearchParams(searchParams);

        VideoListStore.fetchVideoList();

        countryCode
            ? params.set('countryCode', countryCode)
            : params.delete('countryCode');

        trackedAt
            ? params.set('trackedAt', trackedAt)
            : params.set('trackedAt', DateService.getTodayFormatedDate());

        if (onlyNew) {
            params.set('onlyNew', '1');
        } else {
            params.delete('onlyNew');
        }

        navigate(`?${params.toString()}`, { replace: true });
    }, [countryCode, trackedAt, onlyNew, navigate, searchParams]);

    useEffect(() => {
        if (!trackedAt) {
            return;
        }

        const trackedAtDate = DateService.normalize(trackedAt);
        const todayDate = DateService.normalize(new Date());
        const dayTimestamp = 86400000;

        setShowAfterButton(trackedAtDate < todayDate);
        setBeforeDayDate(DateService.formatLocal(new Date(trackedAtDate.getTime() - dayTimestamp)));
        setAfterDayDate(DateService.formatLocal(new Date(trackedAtDate.getTime() + dayTimestamp)));
    }, [trackedAt]);

    const onToggleDay = (mode) => {
        const date = new Date(trackedAt);

        if (mode === 'prev') {
            date.setDate(date.getDate() - 1);
        } else if (mode === 'next') {
            date.setDate(date.getDate() + 1);
        }

        VideoListStore.setTrackedAt(DateService.formatLocal(date));
    }

    return (
        <div className="filters">
            <div
                onClick={() => onToggleDay('prev')}
                className="filters__toggle"
            >
                <span class="material-icons filters__arrow-icon">chevron_left</span>
                <span className="filters__date-text">{beforeDayDate}</span>
            </div>

            <CountrySelector/>

            <label className="filters__checkbox" title={LanguageStore.t('onlyNewTooltip')}>
                <input
                    type="checkbox"
                    checked={onlyNew}
                    onChange={(e) => VideoListStore.setOnlyNew(e.target.checked)}
                />
                <span className="filters__switch" aria-hidden="true"></span>
                <span className="filters__checkbox-text">{LanguageStore.t('onlyNewLabel')}</span>
            </label>

            {showAfterButton ?
                <div
                    onClick={() => onToggleDay('next')}
                    className="filters__toggle"
                >
                    <span className="filters__date-text">{afterDayDate}</span>
                    <span class="material-icons filters__arrow-icon">chevron_right</span>
                </div>
            : null}
        </div>
    );
});

export default Filters;